import type { ChangelogEntry } from './changelog-types';
import { changelogAjuda } from './changelog-ajuda-data';
import { changelogXat } from './changelog-data';

export type ChangelogProductId = 'xat' | 'ajuda';

export type ChangelogSource = {
  id: ChangelogProductId;
  label: string;
  shortLabel: string;
  heroTitle: string;
  heroDescription: string;
  entries: ChangelogEntry[];
};

/** Fallback estático quando a API falha ou ainda não respondeu. */
export const CHANGELOG_FALLBACK_SOURCES: Record<ChangelogProductId, ChangelogSource> = {
  xat: {
    id: 'xat',
    label: 'xat',
    shortLabel: 'xat',
    heroTitle: 'Changelog xat',
    heroDescription:
      'Acompanhe todas as novidades, melhorias e correções de cada versão do xat.',
    entries: changelogXat,
  },
  ajuda: {
    id: 'ajuda',
    label: 'xat Ajuda',
    shortLabel: 'Ajuda',
    heroTitle: 'Changelog xat Ajuda',
    heroDescription:
      'Novidades, melhorias e correções do Help Center — documentação, powers e ferramentas do xat Ajuda.',
    entries: changelogAjuda,
  },
};

/** Metadados estáticos; entradas vêm da API (`/changelog/*`) via `useChangelogSources`. */
export const CHANGELOG_SOURCES: Record<ChangelogProductId, ChangelogSource> = {
  xat: {
    id: 'xat',
    label: 'xat',
    shortLabel: 'xat',
    heroTitle: 'Changelog xat',
    heroDescription:
      'Acompanhe todas as novidades, melhorias e correções de cada versão do xat.',
    entries: [],
  },
  ajuda: {
    id: 'ajuda',
    label: 'xat Ajuda',
    shortLabel: 'Ajuda',
    heroTitle: 'Changelog xat Ajuda',
    heroDescription:
      'Novidades, melhorias e correções do Help Center — documentação, powers e ferramentas do xat Ajuda.',
    entries: [],
  },
};

export const CHANGELOG_PRODUCT_ORDER: ChangelogProductId[] = ['xat', 'ajuda'];

export function isChangelogProductId(value: string): value is ChangelogProductId {
  return value === 'xat' || value === 'ajuda';
}
